<div class="chat-flight-number" [class.chat-flight-number--locked]="locked">
  @if (showLabel) {
    <div class="chat-flight-number__label" i18n="@@chatFlightNumberLabel">
      Do you have a flight number to add?
      @if (isMandatory) {
        <span class="chat-flight-number__required" aria-hidden="true">*</span>
      }
    </div>
  }

  <label class="chat-flight-number__field-wrap">
    <input
      class="chat-flight-number__control"
      type="text"
      aria-label="Flight number"
      autocomplete="off"
      [(ngModel)]="flightNumber"
      [maxlength]="maxLength"
      [disabled]="locked"
      placeholder="e.g. BA2490"
    />
  </label>

  @if (locked && chosenSummary) {
    <div class="chat-flight-number__chosen">{{ chosenSummary }}</div>
  }

  <div class="chat-flight-number__actions">
    <button
      type="button"
      class="chat-flight-number__continue"
      [disabled]="locked || !isValid"
      (click)="onContinue()"
    >
      Continue
    </button>
  </div>
</div>
